import { Box, Typography, Link,useTheme } from "@mui/material";
import { tokens } from "../../theme";

const Footer = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box bgcolor={colors.white[500]} style={{ alignContent: "flex-end", alignItems: "center", height: "50px", position: "sticky", marginTop: "3%"}}>
      <Typography color={colors.black[500]} fontWeight="bold" marginLeft="700px">
        Copyright &copy; {new Date().getFullYear()}
        <Link color={colors.black[500]} href="https://www.zamzambank.com">
          {" "}
          ZamZam Bank S.C.{" "}
        </Link>
      </Typography>
      {/* <Typography>V 0.1</Typography> */}
    </Box>
  );
};
export default Footer;
